export const LOGIN = '/login'



// WEBPACK FOOTER //
// ./src/components/App/routes.js